/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { createContext, PropsWithChildren, ReactElement, useContext } from 'react'
import { AuthInfo, UseAuthHook } from '../hooks/useAuth'

export const AuthContext = createContext<UseAuthHook<AuthInfo>>(null)

export function useAuthContext (): UseAuthHook<AuthInfo> {
  return useContext(AuthContext)
}

export type AuthProviderProps = PropsWithChildren & {
  context: UseAuthHook<AuthInfo>
}

function AuthProvider (props: AuthProviderProps): ReactElement {
  const { children, context } = props
  return (
    <AuthContext.Provider value={context}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
